export default "__VITE_ASSET__11368388__"